import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectSitePagesSettings } from 'core-components/sitebuilder/store/selectors/selectSitePagesSettings'

interface IUseLayoutConfig {
  id?: string
}

export const useLayoutConfig = ({ id }: IUseLayoutConfig) => {
  const sitePagesSettings = useSelector(selectSitePagesSettings)
  return useMemo(() => {
    return sitePagesSettings.find((el) => el.name === id)
  }, [sitePagesSettings, id])
}
